import React from 'react';
import { motion } from 'framer-motion';
import { Award, Trophy, Medal, Crown, Star, Zap, Target, Flame, Lock } from 'lucide-react';

const achievements = [
  {
    id: 1,
    name: 'Primeiro Passo',
    description: 'Complete seu primeiro treino',
    icon: 'target',
    unlocked: true,
    progress: 100,
  },
  {
    id: 2,
    name: 'Dedicação',
    description: 'Complete 5 treinos',
    icon: 'flame',
    unlocked: false,
    progress: 60,
  },
  {
    id: 3,
    name: 'Consistência',
    description: 'Mantenha um streak de 7 dias',
    icon: 'zap',
    unlocked: false,
    progress: 28,
  },
  {
    id: 4,
    name: 'Evolução',
    description: 'Alcance o nível 5',
    icon: 'star',
    unlocked: false,
    progress: 40,
  },
  {
    id: 5,
    name: 'Mestre',
    description: 'Alcance o nível 10',
    icon: 'crown',
    unlocked: false,
    progress: 10,
  },
  {
    id: 6,
    name: 'Campeão',
    description: 'Complete 50 treinos',
    icon: 'trophy',
    unlocked: false,
    progress: 8,
  },
];

const getIcon = (iconName) => {
  const icons = {
    target: Target,
    flame: Flame,
    zap: Zap,
    star: Star,
    crown: Crown,
    trophy: Trophy,
  };
  const Icon = icons[iconName] || Award;
  return Icon;
};

export const AchievementsPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] pb-24 px-6 pt-8" data-testid="achievements-page">
      <motion.div
        className="mb-8"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex items-center gap-3 mb-2">
          <Award className="w-8 h-8 text-neon-lime" />
          <h1 className="font-primary font-black text-4xl text-white uppercase tracking-tighter">
            Conquistas
          </h1>
        </div>
        <p className="text-zinc-500 text-sm">
          Desbloqueie conquistas e mostre seu progresso
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {achievements.map((achievement, index) => {
          const Icon = getIcon(achievement.icon);
          return (
            <motion.div
              key={achievement.id}
              className={`rounded-2xl p-6 border relative overflow-hidden ${
                achievement.unlocked
                  ? 'bg-gradient-to-br from-neon-lime/10 to-utility-success/5 border-neon-lime/30'
                  : 'bg-zinc-900/50 border-white/5'
              }`}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ scale: 1.02 }}
              data-testid="achievement-card"
            >
              {!achievement.unlocked && (
                <div className="absolute top-3 right-3">
                  <Lock className="w-5 h-5 text-zinc-600" />
                </div>
              )}
              <div className="flex items-start gap-4">
                <div
                  className={`w-16 h-16 rounded-2xl flex items-center justify-center ${
                    achievement.unlocked
                      ? 'bg-neon-lime text-black'
                      : 'bg-zinc-800 text-zinc-600'
                  }`}
                >
                  <Icon className="w-8 h-8" />
                </div>
                <div className="flex-1">
                  <h3
                    className={`font-primary font-bold text-xl mb-1 ${
                      achievement.unlocked ? 'text-neon-lime' : 'text-zinc-400'
                    }`}
                  >
                    {achievement.name}
                  </h3>
                  <p className="text-zinc-500 text-sm mb-3">
                    {achievement.description}
                  </p>
                  <div className="space-y-1">
                    <div className="flex justify-between text-xs">
                      <span className="text-zinc-500">Progresso</span>
                      <span
                        className={achievement.unlocked ? 'text-neon-lime font-bold' : 'text-zinc-500'}
                      >
                        {achievement.progress}%
                      </span>
                    </div>
                    <div className="h-2 bg-zinc-800 rounded-full overflow-hidden">
                      <motion.div
                        className={`h-full ${
                          achievement.unlocked
                            ? 'bg-gradient-to-r from-neon-lime to-utility-success'
                            : 'bg-zinc-700'
                        }`}
                        initial={{ width: 0 }}
                        animate={{ width: `${achievement.progress}%` }}
                        transition={{ duration: 0.8, delay: index * 0.1 + 0.2 }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
};
